import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { ActionIcon, Badge, Box, Card, Group, Image, Spoiler, Stack, Text, Transition, UnstyledButton } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import { useRef, useState } from 'react';
import classes from './Notifications.module.css';
import type { NotificationType } from './notificationsData';
export const NotificationMessage: React.FC<NotificationType> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  const [expanded, setExpanded] = useState(false);
  const {
    hovered,
    ref
  } = useHover();
  const spoilerControlRef = useRef<HTMLButtonElement>(null);
  return <Card p={10} radius={5} ref={ref} classNames={{
    root: hovered ? classes.cardHover : classes.card
  }}>
      <Stack gap={10}>
        <Group justify="space-between">
          <Badge variant="light" color="gray" radius="sm">
            {props.title}
          </Badge>
          {props.status === 'new' && <Badge color="lime" radius="sm" classNames={{
          root: classes.badge
        }}>
              {props.status}
            </Badge>}
        </Group>

        {props.image && <Box>
            <Image src={props.image} alt="notification" />
          </Box>}

        <Spoiler maxHeight={80} showLabel={false} hideLabel={false} expanded={expanded} controlRef={spoilerControlRef} classNames={{
        root: classes.spoiler
      }}>
          <Box w="100%" style={{
          wordBreak: 'break-word'
        }}>
            <Text fz={10} c={hovered ? 'white' : 'var(--text-dark)'}>
              {props.time}
            </Text>
            <Text fz={13} lineClamp={expanded ? 0 : 3} c={hovered ? 'white' : 'var(--text-dark)'}>
              {props.content}
            </Text>
          </Box>
        </Spoiler>

        <Group align="center" justify="space-between" h={30}>
          <Transition mounted={hovered} transition="fade" duration={400} timingFunction="ease">
            {styles => <Group style={styles} gap={6}>
                <ActionIcon size={30} radius={5} classNames={{
              root: classes.actionIcon
            }}>
                  <Icons className="icon-pr-line-checked-circle-broken" fontSize={18} />
                </ActionIcon>
                <ActionIcon size={30} radius={5} bg="var(--icon-primary)">
                  <Icons className="icon-pr-line-trash" fontSize={18} />
                </ActionIcon>
              </Group>}
          </Transition>

          <UnstyledButton ref={spoilerControlRef} onClick={() => setExpanded(!expanded)} ml="auto">
            {expanded ? <Group gap={4}>
                <Text tt="uppercase" fz={10} c={hovered ? 'white' : 'var(--text-dark)'}>
                  {i18n._('Hide')}
                </Text>
                <Icons className="icon-pr-line-chevron-up" fontSize={16} />
              </Group> : <Group gap={4}>
                <Text tt="uppercase" fz={10} c={hovered ? 'white' : 'var(--text-dark)'}>
                  {i18n._('Show all')}
                </Text>
                <Icons className="icon-pr-line-chevron-down" fontSize={16} />
              </Group>}
          </UnstyledButton>
        </Group>
      </Stack>
    </Card>;
};